import React from 'react';
import './comments.css'
class CommentSystem extends React.Component {
    render() {
        return (
           <div>
                <div id='commentSystemWrap'>
                    <input id='commentInput' type='text' />
                    <button id='commentSubmitBtn'>Post</button>
                </div>
           </div>
        )
    }
}
export default CommentSystem